import GraphContent from "../graph_content";
import { setInitSetting } from "./set_init_setting";
import VueStore from "../../../store/VueStore";
import router from "../../../router";
import MstGraphService from "../../../services/mst_graph_service";
import AuthStoreAPI from "../../../services/auth_store_service";
import { Auth } from "aws-amplify";
import { AuthStoreType } from "@/types/types";

const switchContent = (self: GraphContent) => {
  self.graphContentArea = true;
  self.graphContent = false;
  self.initSettingArea = true;
  self.settingIcon = false;
  self.graphLoading = false;
};

const signOutAndRedirect = () => {
  Auth.signOut()
    .then(() => {
      // 現在の画面がサインイン画面でなかったらサインイン画面に遷移する
      if (location.pathname !== "/signIn") {
        router.push("/signIn");
      }
    })
    .catch((err: object) => {
      console.error(err);
    });
};

/**
 *
 * @param self
 */
export async function getGraphSetting(self: GraphContent) {
  if (VueStore.state.token === null) {
    return router.push("/signIn");
  }
  try {
    self.graphSettingErrors = "";
    self.canvasID = "graphDrawArea-" + self.graphID;
    const userID = self.userID;
    self.mst_graph = await MstGraphService.query(userID, self.graphID);
    self.authStores = await AuthStoreAPI.query(userID);
    if (self.mst_graph !== null) {
      self.authStores.forEach((store: AuthStoreType) => {
        if (self.mst_graph.authStoreName === store.store_name) {
          self.auth_store = store;
        }
      });
    }
    if (self.mst_graph === null) {
      switchContent(self);
    } else {
      setInitSetting(self);
    }
    return;
  } catch (e) {
    console.error(e);
    // 未認証ユーザでアクセスするとサインアウト処理をしてサインイン画面に遷移させる
    // TODO: レスポンスの内容が変わったら修正しないといけない...
    if (e === "No current user") {
      return signOutAndRedirect();
    }
    if (e.errors) {
      e.errors.forEach((error: { [key: string]: string }) => {
        // 認証エラーが発生したらサインアウト処理をしてサインイン画面に遷移させる
        // TODO: レスポンスの内容が変わったら修正しないといけない...
        if (error.message.indexOf("401") > 0) {
          return signOutAndRedirect();
        }
      });
    }
    switchContent(self);
    // 認証以外のエラーでグラフ設定の取得に失敗したらグラフ設定画面にエラーメッセージを表示するよう修正
    self.graphSettingErrors = self.$t(
      "message.failedToRetrieveSettings"
    ) as string;
    return;
  }
}
